import { useLocation } from 'react-router-dom'

import { ReadonlyFieldConfig } from '../../features/ui-config'
import { useConfigContext } from '../../features/ui-config'
import i18n from '../../utils/i18n'

type FieldTranslation = {
  [key: string]: string
}

export const AttachmentCategoryBodyTemplate = (attachmentCategory: string) => {
  const { uiConfig: config } = useConfigContext()
  const { language } = i18n
  const location = useLocation()

  if (!attachmentCategory) return null

  const isDespatchAdviceInURL = location.pathname.includes(
    '/orders/despatch-advice',
  )
  const isInvoicesInURL = location.pathname.includes('/orders/invoice')
  const isDeliveryForecastDespatchAdviceInURL = location.pathname.includes(
    '/delivery-forecasts/despatch-advice',
  )

  let translationsName = ''
  let attachmentCategories: ReadonlyFieldConfig['options'] = []

  if (isDespatchAdviceInURL) {
    attachmentCategories =
      config.despatchAdvice.uploadAttachment.category.options ?? []
  }
  if (isInvoicesInURL) {
    attachmentCategories =
      config.invoice.uploadAttachment.category.options ?? []
  }
  if (isDeliveryForecastDespatchAdviceInURL) {
    attachmentCategories =
      config.deliveryForecastDespatchAdvice.uploadAttachment.category.options ??
      []
  }

  attachmentCategories?.forEach(element => {
    const names: FieldTranslation = element.name
    if (element.code === attachmentCategory) {
      translationsName = names[language]
    }
  })

  return <>{translationsName}</>
}
